// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 1175 ? "PrototypeViewer" : chunkId) + "." + {"1175":"19a267c8bc0938cd17e7","2054":"19a267c8bc0938cd17e7","8261":"a6b5b366aedb74b76eef","9645":"f6cccc140833cb7266d4"}[chunkId] + ".chunk.css";
};